import $ from 'jquery';
import cleanMathTags from './cleanMathTags';

import constants from './constants';
import OCError from '../../Exceptions/OCError';

const regexp = {
    block: /^\\\[([\s\S]*)\\]$/,
    inline: /^\\\(([\s\S]*)\\\)$/,
};

class ElementsMath {
    constructor(mathRenderingService) {
        this.mathRenderingService = mathRenderingService;
    }

    mathElement(elements) {
        const $mathElements = cleanMathTags
            .cleanElement($(elements))
            .addClass(`js-math math-formula ${this.mathRenderingService.elementClassName}`);

        this.addMathConfigurationFromElementContent($mathElements);

        this.mathRenderingService.elementsPreProcessor($mathElements);

        return this.mathRenderingService.render($mathElements);
    }

    addMathConfigurationFromElementContent($mathElements) {
        $mathElements.each((n, element) => {
            const $element = $(element),
                content = $element.text(),
                latex = getLatexFromContent(content),
                mathConf = {
                    inline: (getModeFromLatexContent(content) === ElementsMath.IS_DISPLAY_INLINE),
                    latex: latex,
                };

            this.mathRenderingService.setMathConfiguration(element, mathConf);

            $element.addClass(mathConf.inline ? 'is-inline' : 'is-block');
        });

        return $mathElements;
    }

    updateElement(element, math) {
        if (!math) {
            math = this.getMathFromElement(element);
        }

        this.mathRenderingService.setMathConfiguration(element, math);
        return this.mathRenderingService.update(element);
    }

    addMathToElement(element, math) {
        const delimiters = math.inline ? constants.MATH_TEXT_WRAPPERS_INLINE : constants.MATH_TEXT_WRAPPERS_BLOCK,
            elementTagName = math.inline ? 'span' : 'div',
            content = math.latex ? (delimiters[0] + math.latex + delimiters[1]) : '',
            $newElement  = $('<' + elementTagName + '>');

        $newElement.text(content).appendTo(element);

        return this.mathElement($newElement);
    }

    unMathElement(elements) {
        $(elements).each((n, element) => {
            const $element = $(element),
                math = this.mathRenderingService.getMathConfiguration(element),
                $mathElement = $('<math>');

            cleanMathTags.revert($element);

            const delimiters = math.inline ? constants.MATH_TEXT_WRAPPERS_INLINE : constants.MATH_TEXT_WRAPPERS_BLOCK;
            const content = delimiters[0] + math.latex + delimiters[1];

            $element.replaceWith($mathElement.text(content));
        });
    }

    getMathElement(element) {
        const $parent = $(element).closest('.js-math');

        if ($parent.length === 0) {
            OCError.throwException(constants.MATH_NOT_A_MATH_ELEMENT_EXCEPTION);
        }

        return $parent[0];
    }

    getMathFromElement(element) {
        return this.mathRenderingService.getMathFromElement(this.getMathElement(element));
    }

    isMathElement(element) {
        return !!$(element).closest('.js-math').length;
    }
}

ElementsMath.IS_DISPLAY_BLOCK = 'block';
ElementsMath.IS_DISPLAY_INLINE = 'inline';

function getModeFromLatexContent(content) {
    if (content.match(regexp.block)) {
        return ElementsMath.IS_DISPLAY_BLOCK;
    }

    return ElementsMath.IS_DISPLAY_INLINE;
}

function getLatexFromContent(content) {
    return content.match(/\\[([]([\s\S]*)\\[)\]]/)[1];
}

export default ElementsMath;
